'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './station_requirements.routes';

export class StationRequirementsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.station_requirements', [uiRouter])
  .config(routes)
  .component('stationRequirements', {
    template: require('./station_requirements.html'),
    controller: StationRequirementsComponent,
    controllerAs: 'stationRequirementsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/station_requirements/station_requirements.component.js